// extracted by mini-css-extract-plugin
module.exports = {"className":"textInspirationalTitleXXL_className__27cEz"};